// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__zLcfb","buttons":"PendingPaymentAlert_buttons__lGPIx"};